export default {
  namespaced: true,
  state: {
    userInfo: {},
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setShopName(state, shopName) {
      state.userInfo.shopName = shopName;
    },
  },
  getters: {
    // 店铺或工作室
    shopOrStudioTag: (state) => {
      if (state.userInfo.shopTypeId === 65) {
        return `工作室`;
      }
      return `店铺`;
    },
  },
};
